<template>
  <section class="drill-down-modal">
    <SwitchGraphic :buttons="content.buttons" />
    <div class="drill-down-modal__filter">
      <FilterGeoArea class="drill-down-modal__filter__geo" />
    </div>
    <component :is="activeGraphic" :content="content[`${activeGraphic}`]" />
  </section>
</template>

<script>
import HistoricalTrend from "./HistoricalTrend.vue";
import PreviousYear from "./PreviousYear.vue";
import SwitchGraphic from "./SwitchGraphic.vue";
import FilterGeoArea from "../filters/FilterGeoArea.vue";
import { mapGetters } from "vuex";
export default {
  name: "ModalDrillDown",
  props: {
    content: { type: Object },
  },
  components: { HistoricalTrend, PreviousYear, SwitchGraphic, FilterGeoArea },
  computed: {
    ...mapGetters({
      activeGraphic: "ui/activeGraphic",
    }),
  },
};
</script>

<style lang="scss" scoped>
.drill-down-modal {
  height: calc(100vh - $button-drill-height-open);
  z-index: 20;
  width: 100vw;
  border-radius: toRem(30) toRem(30) 0 0;
  background-color: var(--source-color-dark);
  overflow: hidden;

  &__filter {
    height: $filter-drill-height;
    width: 100%;
    border-bottom: 1px solid $white-02;

    &__geo {
      width: fit-content;
      margin: auto;
    }
  }
}
</style>
